
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet,useLocation, useNavigate } from 'react-router-dom';

import { buttonStyles, buttonStylesBlue } from '../../Components/docsAdministrative/JsObjectStyles';

const Statistiques = () => {

    const navigate = useNavigate();
    const { pathname} = useLocation();
    const { i18n } = useTranslation();

    return (
        <>
            <div className='frame5Profile'>{i18n.t('High Tech Hires')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}> {i18n.t('Statistiques')}</span> </div>
            <h4 className='titlesociete'>
                {i18n.t('Statistiques')}
            </h4>
            <div className='frame7TableMissionBDCAdmin'>
                <div className='frame8TableMissionBDCAdmin'>

                    <Button
                        className='frame29CvTheque'
                        onClick={() => {
                            navigate('/admin/statistiques', { replace: true });
                        }}
                        style={pathname.substring(pathname.lastIndexOf('/') + 1)=='statistiques'?{...buttonStylesBlue(),...{background: '#E7EAF9',color:'#214DCE',borderRadius:'60px'}}:{...buttonStyles(),...{borderRadius:'60px'}}}
                    >
                        {i18n.t('Flux')}
                    </Button>
                    <Button
                        className='frame31CvTheque'
                        onClick={() => {
                            navigate('/admin/statistiques/aoCandidatures', { replace: true }
                            );
                            //navigate('/admin/InterruptionsMissions/Traitees');
                            //setAllInterruption(false);
                        }}
                        variant='test'

                        style={pathname.substring(pathname.lastIndexOf('/') + 1)=='aoCandidatures'? {...buttonStylesBlue(),...{background: '#E7EAF9',color:'#214DCE',borderRadius:'60px'}}:{...buttonStyles(),...{borderRadius:'60px'}} }
                        //style={selectedFrameCvTheque}
                        //style={
                        //    allInterruption == false  ?
                        //        selectedFrameCvTheque:
                        //        notSelectedFrameCvTheque
                        //}
                    >
                        {i18n.t('AO et candidatures')}
                    </Button>
                    <Button
                        className='frame31CvTheque'
                        onClick={() => {
                            navigate('/admin/statistiques/missions', { replace: true }
                            );
                            //navigate('/admin/InterruptionsMissions/Traitees');
                            //setAllInterruption(false);
                        }}
                        variant='test'

                        style={pathname.substring(pathname.lastIndexOf('/') + 1)=='missions'? {...buttonStylesBlue(),...{background: '#E7EAF9',color:'#214DCE',borderRadius:'60px'}}:{...buttonStyles(),...{borderRadius:'60px'}} }
                        //style={selectedFrameCvTheque}
                        //style={
                        //    allInterruption == false  ?
                        //        selectedFrameCvTheque:
                        //        notSelectedFrameCvTheque
                        //}
                    >
                        {i18n.t('Missions')}
                    </Button>
                    <Button
                        className='frame31CvTheque'
                        onClick={() => {
                            navigate('/admin/statistiques/echancierMarges', { replace: true }
                            );
                            //navigate('/admin/InterruptionsMissions/Traitees');
                            //setAllInterruption(false);
                        }}
                        variant='test'

                        style={pathname.substring(pathname.lastIndexOf('/') + 1)=='echancierMarges'? {...buttonStylesBlue(),...{background: '#E7EAF9',color:'#214DCE',borderRadius:'60px'}}:{...buttonStyles(),...{borderRadius:'60px'}} }
                        //style={selectedFrameCvTheque}
                        //style={
                        //    allInterruption == false  ?
                        //        selectedFrameCvTheque:
                        //        notSelectedFrameCvTheque
                        //}
                    >
                        {i18n.t('Chiffre d\'affaires et marges')}
                    </Button>
                </div>
            </div>

            <Outlet/>
        </>
    );
};

export default Statistiques;